const ReviewersList = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/reviewers/reviewersList/ReviewersList.vue"
  );
const Eligibility = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/reviewers/eligibility/Eligibility.vue"
  );

export default [
  {
    path: "list",
    name: "admin-reviewers-list",
    component: ReviewersList,
  },
  {
    path: "eligibility",
    name: "admin-reviewers-eligibility",
    component: Eligibility,
  },
];
